
import { Vue, Component } from 'vue-property-decorator'
import { MutationTypes } from '../store/mutations'

@Component({
	name: 'Footer',
	components: {}
})
export default class Footer extends Vue {
	readonly urlSoGE = 'https://www.geog.ox.ac.uk/'
	readonly urlINPA = 'https://www.gov.br/mcti/pt-br/rede-mcti/inpa/'
	readonly urlINPE = 'https://www.gov.br/inpe/pt-br'
	readonly urlCemaden = 'https://www.gov.br/mcti/pt-br/rede-mcti/cemaden'
	readonly contactUrl: string = 'viewpoint@the-iea.org'
	readonly deliveredByLabel = 'Website delivered by'
	readonly contactLabel = 'Contact'

	get contactHref(): string {
		let href = `mailto:viewpoint@the-iea.org`
		if (this.contactUrl === 'WCSSPProgrammeOffice@metoffice.gov.uk') {
			href += `?subject=VIEWPoint query`
		}
		return href.replace(/ /g, '%20')
	}

	get language() {
		return this.$tStore.state.language
	}

	set language(value) {
		this.$tStore.commit(MutationTypes.SET_LANGUAGE, value)
	}
}
